import { Flex, Pagination } from '@frontend/legacy-components';

import type { Notification } from '../types';
import NotificationsList from './NotificationsList';

type NotificationsTabPanelPropTypes = {
  notifications: Notification[];
  currentPage: number;
  totalItems?: number;
  itemsPerPage: number;
  onChangePage: (arg0: number) => void;
  customEmptyComponent?: React.ReactNode;
};

const NotificationsTabPanel: React.FC<NotificationsTabPanelPropTypes> = ({
  notifications,
  currentPage,
  totalItems,
  itemsPerPage,
  onChangePage,
  customEmptyComponent,
}) => (
  <>
    <NotificationsList
      notifications={notifications}
      customEmptyComponent={customEmptyComponent}
    />
    <Flex
      justifyContent="right"
      padding={1}
      borderTop="1px solid"
      borderTopColor="separator.border"
      position="sticky"
      bottom={0}
      background="page.surface"
      borderBottomRadius="lg"
    >
      <Pagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onChangePage={onChangePage}
      />
    </Flex>
  </>
);

export default NotificationsTabPanel;
